import { all, call, takeEvery, fork } from "redux-saga/effects";
import requestFunction from "../Utils/SagaGenericFunction";
import newSGF from "../Utils/newSGF"

import {  ADD_LOAN, FETCH_ALL_LOANS, ACTIVATE_LOAN, DEACTIVATE_LOAN, UPDATE_LOAN, FETCH_ALL_TOTAL_LOAN_DETAILS, FETCH_LOAN_BY_ID, EXPORT_LOANS, FETCH_LOAN_SELECT, FETCH_ALL_TOTAL_LOAN_BENEFICIARY_DETAILS, ADD_CM_TO_LOAN, FETCH_ALL_LOAN_BENEFICIARIES_TO_LOAN, EXPORT_LOAN_BENEFICIARIES_BY_LOAN, DOWNLOAD_LOAN_BULK_TEMPLATE, ADD_BULK_LOAN } from "../ActionTypes";
import { addNewLoanSuccess, fetchLoansSuccess, activateLoanSuccess, deactivateLoanSuccess,updateLoanSuccess, fetchAllTotalLoanDetailsSuccess, fetchLoanByIdSuccess, exportLoansSuccess, fetchLoanSelectSuccess, fetchAllTotalLoanBeneficiaryDetailsSuccess, addCMToLoanSuccess, fetchLBToLoanSuccess, exportLBbyLoanSuccess, downloadBulkLoanSuccess, addBulkLoanSuccess, addNewLoanFailure } from "../Actions";
import {  createLoan, getAllLoans, activateLoans, deactivateLoans, updateLoan, getAllTotalLoanDetails, getLoanById, exportLoans, getAllLoanSelect, getAllTotalLoanBeneficiaryDetails, createLoanBeneficiary, getAllLBToLoan, exportLBByLoan, downloadLoanBulkTemplateApi, createBulkLoansApi} from "../Api";

// =================Create New Loan sagas================

const createLoansRequest = function* ({ payload }) {
  yield call(newSGF, addNewLoanSuccess, addNewLoanFailure, createLoan, payload);
};

export const createLoans = function* () {
  yield takeEvery(ADD_LOAN, createLoansRequest);
};


// =================fetch all Loans sagas================

const fetchAllLoansRequest = function* ({ payload }) {
  yield call(requestFunction, fetchLoansSuccess, getAllLoans, payload);
};

export const fetchAllLoans = function* () {
  yield takeEvery(FETCH_ALL_LOANS, fetchAllLoansRequest);
};


// =================Activate Loans sagas================

const activateLoanRequest = function* ({ payload }) {
  yield call(requestFunction, activateLoanSuccess, activateLoans, payload);
};

export const activateLoan = function* () {
  yield takeEvery(ACTIVATE_LOAN, activateLoanRequest);
};


// =================Deactivate Loans sagas================

const deactivateLoanRequest = function* ({ payload }) {
  yield call(requestFunction, deactivateLoanSuccess, deactivateLoans, payload);
};

export const deactivateLoan = function* () {
  yield takeEvery(DEACTIVATE_LOAN, deactivateLoanRequest);
};

// =================Fetch Loan by Id sagas================

const fetchLoanByIdRequest = function* ({ payload }) {
  yield call(requestFunction, fetchLoanByIdSuccess, getLoanById, payload);
};

export const fetchTheLoanById = function* () {
  yield takeEvery(FETCH_LOAN_BY_ID, fetchLoanByIdRequest);
};

// =================Update Loan sagas================
const updateLoanRequest = function* ({ payload }) {
  yield call(requestFunction, updateLoanSuccess, updateLoan, payload);
};

export const updateTheLoan = function* () {
  yield takeEvery(UPDATE_LOAN, updateLoanRequest);
};

// =================FETCH ALL Loans Total Details sagas================
const fetchAllLoanTotalDetailsRequest = function* ({ payload }) {
  yield call(requestFunction, fetchAllTotalLoanDetailsSuccess, getAllTotalLoanDetails, payload);
};

export const fetchAllTotalLoanDetails = function* () {
  yield takeEvery(FETCH_ALL_TOTAL_LOAN_DETAILS, fetchAllLoanTotalDetailsRequest);
};

// =================Export Loans sagas================
const exportLoansRequest = function* ({ payload }) {
  yield call(requestFunction, exportLoansSuccess, exportLoans, payload);
};

export const exportTheLoans = function* () {
  yield takeEvery(EXPORT_LOANS, exportLoansRequest);
};

// =================FETCH Loan Select sagas================
const fetchLoanSelectRequest = function* ({ payload }) {
  yield call(requestFunction, fetchLoanSelectSuccess, getAllLoanSelect, payload);
};

export const fetchTheTrainerSelect = function* () {
  yield takeEvery(FETCH_LOAN_SELECT, fetchLoanSelectRequest);
};

// =================FETCH ALL Total Loan Beneficiary sagas================
const fetchAllLoanBeneficiaryTotalDetailsRequest = function* ({ payload }) {
  yield call(requestFunction, fetchAllTotalLoanBeneficiaryDetailsSuccess, getAllTotalLoanBeneficiaryDetails, payload);
};

export const fetchAllTotalTrainersDetails = function* () {
  yield takeEvery(FETCH_ALL_TOTAL_LOAN_BENEFICIARY_DETAILS, fetchAllLoanBeneficiaryTotalDetailsRequest);
};

// =================Create New Loan Benefiary sagas================

const createLBRequest = function* ({ payload }) {
  yield call(requestFunction, addCMToLoanSuccess, createLoanBeneficiary, payload);
};

export const createLB = function* () {
  yield takeEvery(ADD_CM_TO_LOAN, createLBRequest);
};


// =================fetch all Loan Beneficiaries to loan sagas================

const fetchAllLBToLoanRequest = function* ({ payload }) {
  yield call(requestFunction, fetchLBToLoanSuccess, getAllLBToLoan, payload);
};

export const fetchAllLBToLoan = function* () {
  yield takeEvery(FETCH_ALL_LOAN_BENEFICIARIES_TO_LOAN, fetchAllLBToLoanRequest);
};

// =================Export LB by Loan sagas================
const exportLBbyLoanRequest = function* ({ payload }) {
  yield call(requestFunction, exportLBbyLoanSuccess, exportLBByLoan, payload);
};

export const exportTheLBbyLoan = function* () {
  yield takeEvery(EXPORT_LOAN_BENEFICIARIES_BY_LOAN, exportLBbyLoanRequest);
};

// =================Download Bulk Loans Template sagas================
const downloadBulkLoanRequest = function* ({ payload }) {
  yield call(requestFunction, downloadBulkLoanSuccess, downloadLoanBulkTemplateApi, payload);
};

export const downloadTheBulkLoans = function* () {
  yield takeEvery(DOWNLOAD_LOAN_BULK_TEMPLATE, downloadBulkLoanRequest);
};

// =================Add Bulk Loans sagas================

const createBulkLoanRequest = function* ({ payload }) {
  yield call(requestFunction, addBulkLoanSuccess, createBulkLoansApi, payload);
};

export const createTheBulkLoans = function* () {
  yield takeEvery(ADD_BULK_LOAN, createBulkLoanRequest);
};

export default function* rootSaga() {
    yield all([fork(createLoans), fork(fetchAllLoans), fork(activateLoan), fork(deactivateLoan), fork(fetchTheLoanById), fork(updateTheLoan), fork(fetchAllTotalLoanDetails), fork(exportTheLoans), fork(fetchTheTrainerSelect), fork(fetchAllTotalTrainersDetails), fork(fetchAllLBToLoan), fork(createLB), fork(exportTheLBbyLoan), fork(downloadTheBulkLoans), fork(createTheBulkLoans)]);
  }